/**
 * This the value of the Permission when it is not defined
 * It means that we inherit the permission from the group
 *
 * @type {string} - The value of the permission
 */
export const PERMISSION_NOT_DEFINED_VALUE = 'null'
